import React from "react";
import CrudPage from "@/components/CrudPage";
import { Truck } from "@phosphor-icons/react";

export default function Suppliers() {
  return (
    <CrudPage
      title="Suppliers"
      subtitle="Companies that supply assets, operators and transport"
      endpoint="/suppliers"
      columns={[
        { key: "name", label: "Name", render: (v) => <span className="font-semibold">{v}</span> },
        { key: "contact_name", label: "Contact" },
        { key: "phone", label: "Phone" },
        { key: "email", label: "Email" },
        { key: "is_transport_provider", label: "Transport", render: (v) => v ? (
          <span className="inline-flex items-center gap-1 bg-equipr-yellow/25 border border-equipr-yellow text-equipr-black text-[11px] font-bold px-1.5 py-0.5" data-testid="transport-provider-badge">
            <Truck size={11} weight="bold" /> Transport Provider
          </span>
        ) : "—" },
      ]}
      fields={[
        { key: "name", label: "Supplier Name", required: true, full: true },
        { key: "contact_name", label: "Contact Name" },
        { key: "phone", label: "Phone" },
        { key: "email", label: "Email" },
        { key: "is_transport_provider", label: "Transport Provider", type: "checkbox", checkboxLabel: "This supplier transports plant & equipment", default: false, full: true },
        { key: "notes", label: "Notes", type: "textarea", full: true },
      ]}
    />
  );
}
